// extracted by mini-css-extract-plugin
module.exports = {"right":"styles_right__1Ji0g"};